import { combineReducers } from 'redux';
import byId from './byId';
import allIds from './allIds';
import count from './count';
import hasMore from './hasMore';

export default combineReducers({ byId, allIds, count, hasMore });
